import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'online-test',
    pathMatch: 'full'
  },
  {
    path: 'online-test',
    loadChildren: () => import('./online-test/online-test.module').then(m => m.OnlineTestModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
